import gql from 'graphql-tag';

const PROFILE_DOCUMENT_DELETE= gql`
mutation profileDocumentDelete($id: ID!) { 
  profileDocumentDelete(id: $id) 
  } 
`;

export default PROFILE_DOCUMENT_DELETE;